import React from 'react';
import Remark from './Remark';
import '../../CommonCSS/SocietyCSS.css'

const RemarkApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Student Remarks</h5>
          </div>  
        </div>
        <Remark/>
      </div>
    </div >
  );
};

export default RemarkApp;
